import * as types from "../actions/actionTypes";
const initialState = {
  modalStatus: false,
  modalData: [],
  askLoading: false,
  files: [],
  countToast: false,
  completedFiles: []
};

const DownloadFile = (state = initialState, action) => {
  switch (action.type) {
    case types.DOWNLOAD_FILE_MODAL_DATA:
      return { ...state, modalStatus: true, modalData: action.data };
    case types.DOWNLOAD_FILE_CLOSE_MODAL:
      return { ...state, modalStatus: false, modalData: [] };
    case types.DOWNLOAD_FILE_REPORT_REQUEST:
      return { ...state, askLoading: true };
    case types.DOWNLOAD_FILE_REPORT_SUCCESS:
      let files = state.files;
      files.push(action.payLoad);
      return {
        ...state,
        askLoading: false,
        modalStatus: false,
        modalData: [],
        countToast: true,
        files
      };
    case types.DOWNLOAD_FILE_REPORT_FAILURE:
      return { ...state, askLoading: false };
    case types.DOWNLOAD_FILE_COUNT_TOAST_TOGGLE:
      return { ...state, countToast: !state.countToast };
    case types.DOWNLOAD_FILE_CHECK_FILES_SUCCESS:
      let completedFiles = state.completedFiles;
      action.payLoad.forEach(item => {
        state.files.forEach((file, i) => {
          if (file.id === item.id && item.status === 1) {
            state.files.splice(i, 1);
            completedFiles.push({ ...item, toast: true });
          }
        });
      });
      state.files = state.files.filter(item => {
        let found = false;
        action.payLoad.forEach(value => {
          if (value.id === item.id) {
            found = true;
          }
        });
        if (found) {
          return item;
        }
      });
      return {
        ...state,
        completedFiles
      };
    case types.DOWNLOAD_FILE_TOASTED:
      state.completedFiles.forEach(file => {
        if (file.id === action.payLoad) {
          file.toast = false;
        }
      });
      return { ...state };
    default:
      return state;
  }
};

export default DownloadFile;
